module.exports = __webpack_public_path__ + "img/tcap.885098f3.svg";